
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'common/components/elements/icons';
import EmojiContent from 'common/components/modules/emoji-content';
// import Input from 'common/components/elements/inputs/inputs';
import Button from 'common/components/elements/buttons/primary';
import CreateEditModal from 'common/components/modules/modal-wrapper';
import DateFormatter from 'common/utils/DateFormatter';
import { toast } from 'react-toastify';
import toaster from 'common/utils/toast';
import membersiteLogo from 'assets/images/mms-profile.svg'
import './style.scss';
import QueryParams from 'admin/utils/QueryParams';
import { isQuillEmpty } from 'common/utils/utils';
import Loader from './loader.png'
import { history } from 'admin/state/store';
// import queryString from 'query-string';
import { createPortal } from 'react-dom';

import ReactQuill, { Quill } from 'react-quill';
import AutoLinks from 'quill-auto-links';
import { copyText, quillUtils } from 'common/utils/utils.js';
import classNames from 'classnames';

Quill.register("modules/autoLinks", AutoLinks);
// Quill.register({}, true);

// const MAX_CARD_HEIGHT = 120;

const utils = quillUtils();

const MemberNotes = ({
   insideChat,
   notes,
   avatar,
   deleteNote,
   addNote,
   isFetchingAddNote,
   isFetchingDeleteNote,
   memebrId,
   isFetchingUpdateNote,
   updateNote,
   isMobile,
   screenName,
   insidOrderRequest,
   title,
}) => {
   const unlisten = useRef(null);
   let textareaRef = useRef(null);
   let userIDRef = useRef(null);
   useEffect(() => {
      userIDRef.current = memebrId;
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])
   const [editNoteSection, setEditNoteSection] = useState({
      isEdit: false,
      note: null,
      id: null,
   });
   useEffect(() => {
      // const currentConversation = QueryParams.getParam('conversation');
      const currentPath = window.location.pathname;
      const autoSave = () => {
         const editor = textareaRef?.current?.editor;
         const note = editor?.root?.innerHTML
         let text = editor.getText();
         if(text){
            text = text.trim();
         }
         if(note && !isQuillEmpty(note)){
            addNote(userIDRef.current, { note });
         }
         if(editNoteSection?.isEdit && editNoteSection.note  && !isQuillEmpty(editNoteSection.note) && editNoteSection.originalNote !== editNoteSection.note){
            updateNote(userIDRef.current, editNoteSection.id, { note: editNoteSection.note })
            setEditNoteSection({
               isOpen: false,
               note: null,
               noteId: null,
            })
         }
      }
      const historylisten = () => {
         unlisten.current = history.listen((location, action) => {
            if(['POP'].includes(action)){
               if(location.path  !== currentPath){
                  autoSave();
               }
            }
         });
      }
      historylisten();
      return () => {
         if(unlisten.current){
            unlisten.current();
         }
      }
   }, [addNote, memebrId, textareaRef, editNoteSection, updateNote])

   let cardRef = useRef({});

   const [showMore, setShowMore] = useState(false);
   const [openDeleteModal, setOpenDeleteModal] = useState({
      isOpen: false,
      noteId: null,
   });

   const onCloseDeleteModal = () => {
      setOpenDeleteModal({
         isOpen: false,
         noteId: null,
      })
   }
   return (
      <div
         className={ cx({
            'flex flex-col gap-4 member-note-content': true,
            'w-full h-auto max-w-[550px] mt-6 sm:p-6 bg-panel rounded-lg': !insideChat,
            'mt-6': insideChat,
            [`!mt-0 border border-divider max-ms:!max-w-full`]: insidOrderRequest,
         }) }
      >
         {
            openDeleteModal?.isOpen && openDeleteModal?.noteId && (
               <CreateEditModal
                  type='confirm'
                  onCloseModal={ onCloseDeleteModal }
                  action={ () => deleteNote(memebrId, openDeleteModal.noteId, () => {
                     onCloseDeleteModal();
                  }) }
                  title='Delete note?'
                  description='Are you sure you want to delete this note? This action cannot be undone.'
                  descriptionColorClass='text-secondary'
                  buttonText='Yes, delete'
                  disabled={ isFetchingDeleteNote }
                  nonPrimaryColor
                  textColor='error'
                  icon='delete'
                  iconColor='error'
                  contentWidth='375px'
               />
            )
         }
         {
            !insideChat && (
               <div className='flex flex-col gap-1'>
                  <div className='flex justify-between h-6 items-center'>
                     <span className='panel-header text-major dark:text-major-dark intercom-single-or-member-notes'>{title}</span>
                     {
                        notes?.length > 0 && (
                           <div className='bg-action-12 h-5 w-5 flex items-center justify-center rounded-full'>
                              <span className='text-xs font-medium text-action select-none'>{notes.length > 9 ? '9+' : notes.length}</span>
                           </div>
                        )
                     }
                  </div>
                  <div className='flex gap-2 items-center'>
                     <div className='flex w-5 h-5 min-w-[20px] items-center justify-center'>
                        <Icon
                           name='unpublish'
                           color='secondary'
                           darkColor='secondary-dark'
                           size='lg'
                        />

                     </div>
                     <span className='text-[13px] text-secondary dark:text-secondary-darkleading-[16px]'>Notes are visible only to you</span>
                  </div>
               </div>
            )
         }
         <NotesTextArea
            current=''
            isFetchingSave={ isFetchingAddNote }
            onSave={ (note, callBack) => {
               addNote(memebrId, { note }, () => {
                  if(callBack){
                     callBack();
                  }
               })
            } }
            textareaRef={ textareaRef }
            isNew
            currentNote=''
            showDescription={ !insideChat }
            isMobile={ isMobile }
         />

         {
            notes && notes.map((note, index) => {
               if(!showMore && index > 1){
                  return null;
               }
               const cardId = `member-note-item_${ note.id }`;
               return (
                  <div
                     ref={ ref => cardRef.current = { ...cardRef.current, [note.id]: ref } }
                     style={  {
                        opacity: 1,
                     } }
                     key={ note.id }
                     id={ cardId }
                     className={ cx({
                        'member-note-item flex-col gap-[6px] flex': true,
                        'new-note': 'add' === note.flag,
                        'delete-note': 'delete' === note.flag,
                     }) }
                  >
                     <NoteCard
                        isMobile={ isMobile }
                        note={ note }
                        onClickDelete={ (cardHeight) => {
                           const card = cardRef.current?.[note.id];
                           if(card && card.style){
                              card.style.height = `${ cardHeight }px`
                           }
                           setOpenDeleteModal({
                              isOpen: true,
                              noteId: note.id,
                           })
                        }
                        }
                        editNoteSection={ editNoteSection }
                        setEditNoteSection={ setEditNoteSection }
                        isFetchingUpdateNote={ isFetchingUpdateNote }
                        onSave={ (newNote, callBack) => {
                           if(newNote === note.note){
                              if(callBack){
                                 callBack();
                              }
                              return
                           }
                           updateNote(memebrId, editNoteSection.id, { note: newNote }, () => {
                              if(callBack){
                                 callBack();
                              }
                              setEditNoteSection({
                                 isOpen: false,
                                 note: null,
                                 noteId: null,
                              })
                           })
                        } }
                        avatar={ avatar }
                        showDescription={ !insideChat }
                        screenName={ screenName }
                     />
                  </div>
               )
            })
         }
         {
            notes.length > 2 && (
               <div className='h-5 flex ml-auto'>
                  <Button
                     text={ showMore ? 'Show less' : 'Show all' }
                     iconName={ showMore ? 'arrow-up' : 'arrow-down' }
                     textColor='secondary dark:text-secondary-dark'
                     fontIconColor='secondary dark:text-secondary-dark'
                     fontIconSize='base'
                     textMarginX='0 mr-2'
                     textSize='small'
                     backgroundColor='transparent'
                     padding='0'
                     onClick={ _ => {
                        const bool = !showMore;
                        setShowMore(bool)
                     } }
                  />
               </div>
            )
         }
      </div>
   );
};


const NoteCard = ({
   note,
   onClickDelete,
   editNoteSection,
   setEditNoteSection,
   isFetchingUpdateNote,
   onSave,
   avatar,
   showDescription,
   isMobile,
   screenName,
   // textareaRef
}) => {
   const contentRef = useRef(null);
   const textRef = useRef(null);
   const isSystem = note.is_system;
   const [transactionID, setTransactionID] = useState(null);
   let textareaRef = useRef(null);
   // const [showReadMore, setShowReadMore] = useState(editNoteSection?.showReadMore);
   // const [isShowMore, setIsShowMore] = useState(editNoteSection?.isShowMore);
   // const [scrollHeight, setScrollHeight] = useState(editNoteSection?.scrollHeight);
   // const [height, setHeight] = useState(editNoteSection?.height);
   const editState = editNoteSection?.isEdit && editNoteSection?.id === note.id;
   // useEffect(() => {
   //    let textHeight = 0;
   //    if(contentRef.current && textRef.current){
   //       if(textRef.current) {
   //          textHeight = textRef.current.getBoundingClientRect().height;
   //       }
   //       if(textHeight > MAX_CARD_HEIGHT){
   //          console.log(textHeight, 'textHeight')
   //          setScrollHeight(textHeight + 28 + 16)
   //          setHeight(MAX_CARD_HEIGHT)
   //          contentRef.current.classList.add('overflow-hidden');
   //          textRef.current.classList.add(`truncate-4`);
   //          setShowReadMore(true)
   //       } else {
   //          contentRef.current.classList.add('overflow-visible');
   //          setHeight(contentRef.current.scrollHeight)
   //       }
   //    }

   // // eslint-disable-next-line react-hooks/exhaustive-deps
   // }, [contentRef, textRef])


   // const onSetIsShowMore = () => {
   //    const bool = !isShowMore;
   //    setIsShowMore(bool);
   //    if(!bool) {
   //       setHeight(MAX_CARD_HEIGHT);
   //       contentRef.current.classList.add('overflow-hidden');
   //       textRef.current.classList.add(`truncate-4`);
   //    } else {
   //       contentRef.current.classList.add('overflow-visible');
   //       setHeight(scrollHeight);
   //       textRef.current.classList.remove('truncate-4')
   //    }
   // }

   useEffect(() => {
      const getTransactionID = () => {
         if(isSystem && note?.note && note.note.includes('Auto-blocked due to') && note.note.includes('Transaction ID:')){
            const strArr = note.note.split('Transaction ID:');
            let transactionID = strArr?.[1] || null;
            if(transactionID){
               transactionID = transactionID.trim();
            }
            return transactionID
         }
         return null;
      }

      if(!transactionID && document.getElementById(`member_note_${ note.id }`) && getTransactionID()){
         setTransactionID(getTransactionID())
      }
   }, [isSystem, note.id, note.note, transactionID])

   const onClickCopy = (transactionID) => {
      copyText(transactionID);
      toaster.success(`${ transactionID } has been copied`);
   }
   return (
      <>
         {
            editState  && (
               <NotesTextArea
                  currentNote={ note.note }
                  isFetchingSave={ isFetchingUpdateNote }
                  onSave={ onSave }
                  textareaRef={ textareaRef }
                  showDescription={ showDescription }
                  isMobile={ isMobile }
                  id={ note.id }
                  onSetContent={ (note) => {
                     setEditNoteSection({
                        ...editNoteSection,
                        note: note,
                     });
                  } }
                  onSetEditNoteSection={ data => {
                     setEditNoteSection({
                        ...data,
                     })
                  } }
               />
            )
         }
         {
            !editState && (
               <>
                  <div
                     ref={ contentRef }
                     // style={ height ? {
                     //    height: `${ height }px`,
                     //    // overflow: showReadMore ? 'hidden' : 'visible',
                     // } : {} }
                     role='presentation'
                     onClick={ (e) => {
                        if(e?.target?.tagName === 'A'){
                           return
                        }
                        if(isSystem){
                           return;
                        }
                        setEditNoteSection({
                           isEdit: true,
                           note: note.note,
                           originalNote: note.note,
                           id: note.id,
                        });
                     } }
                     // data-tooltip-content={ isSystem ? ' Added by mymember.site support' : '' }
                     // data-tooltip-id='ams-top-tooltip'
                     className={ cx({
                        'flex flex-col rounded-lg bg-notes py-2 px-[10px] gap-1 min-h-[40px] note-card z-1': true,
                        'cursor-text': !isSystem,

                     }) }
                     id={ `member-note-card-${ note.id }` }
                  >
                     <div className='flex gap-2 '>
                        <div
                           data-tooltip-content={ !isSystem ? screenName : '' }
                           data-tooltip-id='ams-top-tooltip'
                           role='presentation'
                           onClick={ e => {
                              e.stopPropagation();
                              e.preventDefault();
                           } }
                           className={ cx({
                              'flex w-6 h-6 min-w-[24px] cursor-default': true,
                              'rounded-full overflow-hidden': !isSystem,
                           }) }
                        >
                           <img
                              src={  isSystem ? membersiteLogo : avatar  }
                              alt='avatar_src'
                              className='object-cover object-center h-full w-full'
                           />
                        </div>
                        <div className='flex items-center'>
                           <div
                              // style={ showReadMore ? {
                              //    // height: `${ height - 28 }px`,
                              //    overflow: isShowMore ? 'hidden' : 'visible',
                              //    '-webkit-line-clamp': isShowMore ? '4' : 'inherit',
                              // } : {} }
                              ref={ textRef }
                              id={ `member_note_${ note.id }` }
                              dangerouslySetInnerHTML={ { __html: note.note } }
                              // notranslate-content-title
                              className='text-base text-major dark:text-major-dark leading-[20px] whitespace-pre-line select-none note-text note-text-conetnt notranslate'
                           />
                           {
                              transactionID && (
                                 <>
                                    {
                                       createPortal(
                                          <>&nbsp;
                                             <Icon
                                                name='copy'
                                                size='sm'
                                                className='cursor-pointer'
                                                color='secondary'
                                                darkColor='secondary-dark'
                                                onClick={ () => onClickCopy(transactionID) }
                                             />
                                          </>,
                                          document.getElementById(`member_note_${ note.id }`)
                                       )
                                    }
                                 </>
                              )
                           }
                        </div>
                     </div>
                     {/* {
                        showReadMore && (
                           <div
                              role='presentation'
                              onClick={ e => {
                                 e.stopPropagation();
                                 e.preventDefault();
                              } }
                              className='flex h-5 min-h-[20px] z-10 ml-auto'>
                              <Button
                                 text={ isShowMore ? 'show less' : 'show more' }
                                 backgroundColor='transparent'
                                 classNames='h-full'
                                 padding='none'
                                 textColor='placeholder dark:text-placeholder-dark '
                                 textSize='small'
                                 onClick={ onSetIsShowMore }
                              />
                           </div>

                        )
                     } */}
                  </div>
                  <div className='flex h-5 justify-end items-center gap-1'>
                     <span
                        data-tooltip-content={ `${ DateFormatter.convertToUserTz(note.created_at, 'MMM DD, YYYY') } at ${ DateFormatter.convertToUserTz(note.created_at, 'hh:mm A z') }` }
                        data-tooltip-id='ams-top-tooltip-start'
                        className='text-secondary dark:text-secondary-dark text-xs leading-[20px] select-none'>{DateFormatter.timeWithYearsAgo(note.created_at)}</span>
                     {
                        !isSystem && (
                           <div
                              data-tooltip-content='Delete note'
                              data-tooltip-id='ams-top-tooltip-start'
                              className='flex h-5 w-5'>
                              <Button
                                 iconName='delete'
                                 fontIconColor='secondary dark:text-secondary-dark hover:text-error dark:hover:text-error-dark'
                                 padding='0'
                                 backgroundColor='transparent'
                                 onClick={ () => {
                                    let cardHeight = 66;
                                    if(contentRef?.current?.offsetHeight){
                                       cardHeight = contentRef.current.offsetHeight + 26
                                    }
                                    onClickDelete(cardHeight)
                                 } }
                                 fontIconSize='base'
                              />
                           </div>
                        )
                     }
                  </div>
               </>
            )
         }
      </>
   )
}

const NotesTextArea = ({
   isFetchingSave,
   onSave,
   textareaRef,
   isNew,
   currentNote,
   showDescription,
   isMobile,
   id,
   onSetContent,
   onSetEditNoteSection,
   hideSaveButton = false,
   emojiContentXPositions,
   characterLimit,
   placeholder,
   editorWrapperClassName,
   editorClassName,
}) => {
   let NOTE_CHARACTERS_LIMIT = 1000;

   if(characterLimit) {
      NOTE_CHARACTERS_LIMIT = characterLimit
   }

   const [textCount, setTextCount] = useState(currentNote.length);
   const [isFocus, setIsFocus] = useState(false);
   let showEmojisRef = useRef(null);
   let timerFetching = useRef(null);
   let editorIdRef = useRef(null);
   const [content, setContent] = useState(currentNote);
   useEffect(() => {
      const editorId = id || '';
      editorIdRef.current = editorId
      window.addEventListener('click', closeOnClickOutside, false);
      return () => {
         window.removeEventListener('click', closeOnClickOutside, false);
      };
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [isFetchingSave]);
   const closeOnClickOutside = (e) => {
      const cardId = `#member-note-card-${ editorIdRef.current }`;
      const editorId = `#member-notes-editor-${ editorIdRef.current || '' }`;

      if(!e.target.closest(editorId) && !e.target.closest(cardId)) {
         // console.log('closeOnClickOutside')
         onClickSave();
      }
   }
   useEffect(() => {
      return () => {
         clearTimeout(timerFetching.current);
      };
   }, [timerFetching]);

   useEffect(() => {
      const editor = textareaRef?.current?.editor;
      const node = editor.root
      node.addEventListener('paste', onPaste);
      if(!isNew && textareaRef?.current){
         if(editor){
            // const text = editor.getText();
            // if(text){
            //    setTextCount(text.trim().length);
            // }
            node.focus()
            const range = document.createRange();
            range.selectNode(node);
            range.setStart(node, node.childNodes.length);
            range.setEnd(node, node.childNodes.length);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

         }
      }
      return () => {
         node.removeEventListener('paste', onPaste);
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])
   const onClickSave  = () => {
      const editor = textareaRef?.current?.editor;
      const content = editor?.root?.innerHTML
      let text = editor.getText();
      if(text){
         text = text.trim();
      }

      if(!isQuillEmpty(content) && content !== currentNote && !isFetchingSave){
         onSave(content, () => {
            setContent('');
         });
      } else {
         if(onSetEditNoteSection){
            if(isNew){
               setContent('');
            }
            onSetEditNoteSection({
               isOpen: false,
               note: null,
               noteId: null,
            })
         }
      }
   }
   const switchShowEmojis = () => {
      const editableDiv = textareaRef.current;
      editableDiv.focus();
   }

   const addEmoji = (e) => {
      const editableDiv = textareaRef.current
      const sym = e.unified.split('-');
      const codesArray = [];
      sym.forEach(el => codesArray.push(`0x${ el }`));
      const emojiPic = String.fromCodePoint(...codesArray);
      let selection = window.getSelection();

      if((textCount + emojiPic.length) > NOTE_CHARACTERS_LIMIT){
         if(!toast.isActive('member_private_note_limit_reached')){
            toaster.error(`${ NOTE_CHARACTERS_LIMIT } character limit has been reached`,  { toastId: 'member_private_note_limit_reached' })
         }
         return;
      }

      if(selection.rangeCount > 0) {
         let range = selection.getRangeAt(0);
         let emojiNode = document.createTextNode(emojiPic);
         range.insertNode(emojiNode);
         range.collapse(false);
         selection.removeAllRanges();
         selection.addRange(range);
         editableDiv.focus();
      }
   }

   const onPaste = (e) => {
      let clipboardData, pastedData;
      e.stopPropagation();
      e.preventDefault();
      clipboardData = e.clipboardData || window.clipboardData;
      pastedData = clipboardData.getData('Text');
      let text =  textareaRef?.current?.editor?.getText() || '';
      if(text){
         text = text.trim();
      }
      if(text.length + pastedData.length > NOTE_CHARACTERS_LIMIT){
         if(!toast.isActive('member_private_note_limit_reached')){
            toaster.error(`${ NOTE_CHARACTERS_LIMIT } character limit has been reached`,  { toastId: 'member_private_note_limit_reached' })
         }
         e.preventDefault();
         e.stopPropagation();
         return;
      }

      window.document.execCommand('insertText', false, pastedData);
   }
   const modules = {
      toolbar: [],
      autoLinks: {
         paste: true,
         type: true,
      },
   };


   return (
      <div
         id={ `member-notes-content${ id || '' }` }
         className={ cx({
            'flex flex-col gap-[6px]': true,
            'z-[3]': isNew,
            'z-2': !isNew,
         }) }
      >
         <div
            role='presentation'
            onClick={ e => {
               e.preventDefault();
               e.stopPropagation()
            } }
            id={ `member-notes-editor-${ id || '' }` }
            className={ classNames({
               'flex rounded-lg bg-notes min-h-[40px] relative z-1 notes-editor': true,
               [`${ editorWrapperClassName }`]: Boolean(editorWrapperClassName),
            }) }
         >
            <ReactQuill
               modules={ modules }
               value={ content }
               placeholder={ isFocus ? null : placeholder || 'Add private note' }
               ref={ (el) => {
                  textareaRef.current = el;
               } }
               theme={ 'snow' }
               onFocus={ _ => {
                  QueryParams.addQueryParam('open', 'note');
                  setIsFocus(true);

               } }
               className={ cx({
                  // notranslate-content-title
                  'z-1 cursor-text text-sm text-major dark:text-major-dark min-h-[40px] leading-[20px] dont-break-out h-full w-full py-[10px] focus:outline-none notranslate': true,
                  [`${ editorClassName }`]: Boolean(editorClassName),
                  // 'pr-[36px]': isMobile,
                  // 'pr-[70px]': !isMobile,

               }) }
               onBlur={ _ => {
                  if(QueryParams.getParam('open')){
                     QueryParams.removeQueryParam('open');
                  }
                  timerFetching.current = setTimeout(() => {
                     if(!showEmojisRef.current){
                        setIsFocus(false);
                     }
                  }, 200)

               } }
               onChange={ (content, delta, source, editor) => {
                  let html = content;
                  if(isQuillEmpty(content)){
                     html = '';
                  }
                  setTextCount(html.length)
                  setContent(html)
                  if(onSetContent){
                     onSetContent(html)
                  }
               } }
               onKeyDown={ (e) => {
                  let hasSelection = false;
                  const selection = window.getSelection();
                  const isSpecial = utils.isSpecial(e);
                  const isNavigational = utils.isNavigational(e);

                  if(selection) {
                     hasSelection = !!selection.toString();
                  }

                  if(isSpecial || isNavigational) {
                     return true;
                  }
                  if(textCount >= NOTE_CHARACTERS_LIMIT && !hasSelection){
                     if(!toast.isActive('member_private_note_limit_reached')){
                        toaster.error(`${ NOTE_CHARACTERS_LIMIT } character limit has been reached`,  { toastId: 'member_private_note_limit_reached' })
                     }
                     e.preventDefault();
                     e.stopPropagation();
                     return;
                  }

               } }
            />
            <div className='flex absolute mr-2 z-2 right-0 gap-2 h-[40px] items-center'>
               {
                  (isFocus || textCount > 0) && (
                     <EmojiContent
                        switchShowEmojis={ switchShowEmojis }
                        addEmoji={ (e) => addEmoji(e) }
                        isMobile={ isMobile }
                        style={ {
                        // top: '29px',
                           width: '24px',
                           height: '24px',
                        } }
                        size=' w-6 h-6 min-w-[24px] z-4'
                        top={ emojiContentXPositions?.top || '37px' }
                        id={ `member-notes-emoji-content${ id || '' }` }
                        primaryIconSize='20px'
                        iconColor='secondary hover:text-action'
                        darkIconColor='secondary-dark dark:hover:text-action-dark'
                        onSetShowEmojis={ (bool, isOutside) => showEmojisRef.current = !isOutside }
                        xPositions={ emojiContentXPositions }
                     />
                  )
               }
               {
                  textCount > 0 && !hideSaveButton && (
                     <div className='flex w-6 h-6 min-w-[24px] items-center justify-center'>
                        {
                           !isFetchingSave && (
                              <Button
                                 iconName='done'
                                 fontIconColor='secondary dark:text-secondary-dark hover:text-action dark:hover-text-action-dark'
                                 padding='0'
                                 backgroundColor='transparent'
                                 onClick={ onClickSave }
                                 disabled={ isFetchingSave }
                              />
                           )
                        }
                        {
                           isFetchingSave && (
                              <img src={ Loader } alt='' className='h-4 w-4 note-loader' />
                           )
                        }
                     </div>
                  )
               }
            </div>
         </div>
         {
            (showDescription || isFocus) && (
               <div className='flex h-5 items-center justify-end'>
                  <span className='text-xs text-secondary leading-[20px]'>{ `${ textCount } of ${ NOTE_CHARACTERS_LIMIT } characters`}</span>

               </div>
            )
         }

      </div>
   )
}

MemberNotes.propTypes = {
   insideChat: PropTypes.bool,
   notes: PropTypes.array,
   deleteNote: PropTypes.func,
   addNote: PropTypes.func,
   isFetchingAddNote: PropTypes.bool,
   isFetchingUpdateNote: PropTypes.bool,
   isFetchingDeleteNote: PropTypes.bool,
   updateNote: PropTypes.func,
   avatar: PropTypes.string,
   memebrId: PropTypes.number,
   screenName: PropTypes.string,
   isMobile: PropTypes.bool,
   insidOrderRequest: PropTypes.bool,
   title: PropTypes.string,
};
NoteCard.propTypes = {
   avatar: PropTypes.string,
   screenName: PropTypes.string,
   note: PropTypes.object,
   onClickDelete: PropTypes.func,
   editNoteSection: PropTypes.object,
   setEditNoteSection: PropTypes.func,
   onSave: PropTypes.func,
   isFetchingUpdateNote: PropTypes.bool,
   showDescription: PropTypes.bool,
   isMobile: PropTypes.bool,
};
NotesTextArea.propTypes = {
   onSave: PropTypes.func,
   onSetEditNoteSection: PropTypes.func,
   onSetContent: PropTypes.func,
   id: PropTypes.number,
   isFetchingSave: PropTypes.bool,
   showDescription: PropTypes.bool,
   textareaRef: PropTypes.any,
   isNew: PropTypes.bool,
   currentNote: PropTypes.string,
   isMobile: PropTypes.bool,
   hideSaveButton: PropTypes.bool,
   emojiContentXPositions: PropTypes.object,
   characterLimit: PropTypes.number,
   placeholder: PropTypes.string,
   editorWrapperClassName: PropTypes.string,
   editorClassName: PropTypes.string,
};

MemberNotes.defaultProps = {
   insidOrderRequest: false,
   title: 'Notes',
};

export { NotesTextArea }

export default MemberNotes
